import { borderLvlToAdmLvl } from "../constants/WebMapApi";
import ApiStateManager from "./apiStateManager";

const stateManager = ApiStateManager.getInstance();

export const paginatedApiInvoker = async (api, perPage = 10, preCB, loopCB, finalCB, loader = false) => {
  let perPageResults = perPage;
  let data = [];
  let page = 1;
  if (preCB) preCB();

  /**
   * one single loader for all paginated apis
   * when using this loader, pass hideLoader: true in API Config to avoid default API loader
   */
  if (loader) stateManager.setRequestCount(1);

  while (perPageResults === perPage) {
    const { data: apiData } = await api(perPage, page);
    if (loopCB) loopCB(apiData);
    data = data.concat(apiData);
    perPageResults = apiData?.length;
    page++;
  }
  if (finalCB) finalCB(data);
  if (loader) stateManager.setRequestCount(-1);
  return data;
};
/**
 * areaBound = [[[lng,lat],[lng,lat]], [[lng,lat],[lng,lat]]]
 * subArea = [[lng,lat],[lng,lat]]
 * subAreaBoundPoint = [lng,lat]
 */
export const getPolygonFromApiResp = (data) => {
  const paths = [];
  data.forEach((location) => {
    const areaBound = location.polygon || [];
    for (const subArea of areaBound) {
      const subPaths = [];
      for (const subAreaBoundPoint of subArea) {
        const lonlat = {
          lng: subAreaBoundPoint[0],
          lat: subAreaBoundPoint[1],
        };
        subPaths.push(lonlat); // [{lng,lat}]
      }
      paths.push(subPaths); // [[{lng,lat}, {lng,lat}], [{lng,lat}]]
    }
  });
  return paths;
}

const getAdmCondition = (x, borderLvl, location) => {
  switch (borderLvl) {
    case 'ADM1':
      return x.adm1 === location.adminLevel1;
    case 'ADM2':
      return x.adm1 === location.adminLevel1 && x.adm2 === location.adminLevel2;
    case 'ADM3':
      return x.adm1 === location.adminLevel1 && 
        x.adm2 === location.adminLevel2 && 
        x.adm3 === location.adminLevel3;
    default:
      return false;
  }
};

// map polygons to corresponding market share data
export const getPolygonsWithMarketShare = (data = [], marketShares = [], borderLvl) => {
  const paths = [];
  data.forEach((location) => {
    const ms = marketShares.find(x => getAdmCondition(x, borderLvl, location));
    const areaBound = location.polygon || [];
    for (const subArea of areaBound) {
      const subPaths = [];
      for (const subAreaBoundPoint of subArea) {
        const lonlat = {
          lng: subAreaBoundPoint[0],
          lat: subAreaBoundPoint[1],
        };
        subPaths.push(lonlat); // [{lng,lat}]
      }
      paths.push({ poly: subPaths, ms }); // subPaths: [[{lng,lat}, {lng,lat}], [{lng,lat}]]
    }
  });
  return paths;
}

const getMSCondition = (x, borderLvl, ms) => {
  switch (borderLvl) {
    case 'ADM1':
      return ms.adm1 === x.adminLevel1;
    case 'ADM2':
      return ms.adm1 === x.adminLevel1 && ms.adm2 === x.adminLevel2;
    case 'ADM3':
      return ms.adm1 === x.adminLevel1 && 
        ms.adm2 === x.adminLevel2 && 
        ms.adm3 === x.adminLevel3;
    default:
      return false;
  }
};

// when market share data given, get corresponding polygon mapped
export const getPolygonsForMarketShare = (marketShares = [], admPolygons = [], borderLvl) => {
  const msArr = [];
  for (const ms of marketShares) {
    const locations = admPolygons.filter(x => getMSCondition(x, borderLvl, ms));
    locations.forEach(location => {
      const areaBound = location?.polygon || [];
      for (const subArea of areaBound) {
        const subPaths = [];
        for (const subAreaBoundPoint of subArea) {
          const lonlat = {
            lng: subAreaBoundPoint[0],
            lat: subAreaBoundPoint[1],
          };
          subPaths.push(lonlat); // [{lng,lat}]
        }
        msArr.push({ poly: subPaths, ms }); // subPaths: [[{lng,lat}, {lng,lat}], [{lng,lat}]]
      }
    })
  }
  return msArr;
}

export const getUniqueGeohashes = (data) => {
  const uniqueGeohashes = [
    ...new Map(data.map((item) => [item["geohash"], item])).values(),
  ];
  return uniqueGeohashes;
}

// when ibs data given, get corresponding polygon mapped
export const getPolygonsForIBS = (ibsData = [], locations = []) => {
  const ibsArr = [];
  for (const  ibs of ibsData) {
      const location = locations?.find(x => ibs["id"] === x["id"]);
      const areaBound = location?.polygon?.coordinates || [];
      for (const subArea of areaBound) {
        const subPaths = [];
        for (const subAreaBoundPoint of subArea) {
          const lonlat = {
            lng: subAreaBoundPoint[0],
            lat: subAreaBoundPoint[1],
          };
          subPaths.push(lonlat); // [{lng,lat}]
        }
        ibsArr.push({ poly: subPaths, ibs }); // subPaths: [[{lng,lat}, {lng,lat}], [{lng,lat}]]
      }
  }
  return ibsArr;
}

